import urlPrefix from "./apiPrefix";

export const getStatsTicketDetailedGroupDay = (from: string, to: string) => `${urlPrefix.value}/tax-web-control/stats/ticket/ticket/detailed/groupDay/from/${from}/to/${to}`;
export const getStatsTicketLocation = (id: number, date: string) => `${urlPrefix.value}/tax-web-control/stats/ticket/location/${id}/date/${date}`;
export const getStatsTicketLastFive = () => `${urlPrefix.value}/tax-web-control/stats/ticket/last5`;
export const getStatsTicketDate = (date: string) => `${urlPrefix.value}/tax-web-control/stats/ticket/date/${date}`;
export const getStatsTicketSummary = (lpId: number) => `${urlPrefix.value}/tax-web-control/stats/ticket/summary/uid/${lpId}`;
